module.exports = __webpack_public_path__ + "images/5903a08331b5ca70e1eb784f3a40e6b1c.svg";